// @flow

import * as React from 'react';
import type {MarkdocTagSchema} from '@stripe-internal/markdoc/types';
import Box from 'sail/Box';
import {ButtonLink} from 'sail/Button';

type MarkdocTagExternalLinksProps = {|
  tagSchema: MarkdocTagSchema,
  tagName?: string,
|};

export const MarkdocTagExternalLinks = ({
  tagSchema,
  tagName,
}: MarkdocTagExternalLinksProps) => {
  // The Markdoc schema sets "tag" to be the name of the React "tag" when it
  // converts from an Ast of Nodes to an Ast of Tags during the process phase.
  const componentName = tagSchema.tag;

  // Not all tags have associated components (like the curl tag). In this case
  // use the tag name.
  const implementationKeyword = componentName || tagName;

  let implementationButton;
  let usagesButton;

  if (implementationKeyword) {
    const implementationLink = `http://go/lgr/docs/src/apps/docs/components/.*${implementationKeyword}`;
    implementationButton = (
      <ButtonLink
        href={implementationLink}
        icon="external"
        iconPosition="right"
        label="Implementation"
        size="small"
        target="_blank"
      />
    );
  }

  if (tagName) {
    // Some markdoc elements, like "code fences" do not have a tagName since
    // they are native Markdown elements. In this case, we do not know what to
    // livegrep for, so only show the usages link if we know the tagname.

    // Live grep for {% $tagname
    const usagesLink = `http://go/lgr/%7B%25.*${tagName}%20path%3Adocs%2Fcontent`;

    usagesButton = tagName && (
      <ButtonLink
        href={usagesLink}
        icon="external"
        iconPosition="right"
        label="See real world examples of this tag"
        size="small"
        target="_blank"
      />
    );
  }

  return (
    <Box margin={{bottom: 16}} className="MarkdocTagExternalLinks">
      {implementationButton}
      {usagesButton}
    </Box>
  );
};
